/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { AuditMentionsAuditMentionsMatchesGetQueryResponse, AuditMentionsAuditMentionsMatchesGetPathParams, AuditMentionsAuditMentionsMatchesGetQueryParams } from "../models/AuditMentionsAuditMentionsMatchesGet";

export function getAuditMentionsAuditMentionsMatchesGetUrl(mentionMatchId: AuditMentionsAuditMentionsMatchesGetPathParams["mentionMatchId"]) {
  const res = { method: 'GET', url: `/audit-mentions/v1/matches/${mentionMatchId}` as const }
  return res
}

/**
 * @description Returns a mention match by id.
 * @summary Get mention match
 * {@link /audit-mentions/v1/matches/:mentionMatchId}
 */
export async function auditMentionsAuditMentionsMatchesGet(mentionMatchId: AuditMentionsAuditMentionsMatchesGetPathParams["mentionMatchId"], params: AuditMentionsAuditMentionsMatchesGetQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<AuditMentionsAuditMentionsMatchesGetQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getAuditMentionsAuditMentionsMatchesGetUrl(mentionMatchId).url.toString(), params, ... requestConfig })
  return res.data
}